import { render, staticRenderFns } from "./ScreenSuperIntendencia.vue?vue&type=template&id=575330f7&scoped=true"
import script from "./ScreenSuperIntendencia.vue?vue&type=script&lang=js"
export * from "./ScreenSuperIntendencia.vue?vue&type=script&lang=js"
import style0 from "./ScreenSuperIntendencia.vue?vue&type=style&index=0&id=575330f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575330f7",
  null
  
)

export default component.exports